import React from 'react';
import {
  AvailableIcons,
  Icon,
  Typography,
  TypographyType,
  TypographyVariant,
} from '../../../../../../../components-dummy';
import { ToggleActiveStyled } from './EmailDisplaySettingsSection.styles';

interface ToggleActiveButtonProps {
  onToggleClick: VoidFunction;
  isActive: boolean;
  title: string;
}

export const ToggleActiveButton = ({ onToggleClick, isActive, title }: ToggleActiveButtonProps) => {
  return (
    <ToggleActiveStyled onClick={onToggleClick} isActive={isActive}>
      {isActive ? <Icon name={AvailableIcons.EyeCrossed} /> : <Icon name={AvailableIcons.Eye} />}
      <Typography type={TypographyType.Body} variant={TypographyVariant.MediumMedium}>
        {isActive ? 'Hide' : 'Show'} {title}
      </Typography>
    </ToggleActiveStyled>
  );
};
